@if (this.selectedStage) {
<div class="d-flex flex-column gap-2">
  <div class="row align-items-center mt-3 mb-2">
    <div class="col-3">
      <span i18n="@@title">Titel</span>
    </div>
    <div class="col-3">
      <input
        pInputText
        type="text"
        class="w-100"
        [(ngModel)]="this.selectedStage.title"
        [ngModelOptions]="{ updateOn: 'blur' }"
        (ngModelChange)="
            this.stageAdmin.updateStagesField(
              this.selectedStage._id,
              'title',
              this.selectedStage.title
            )
          "
      />
    </div>
    <div class="col"></div>
    <div class="col-auto px-1">
      <i
        class="ri-arrow-left-circle-fill text-primary ri-2x cursor-pointer"
        (click)="selectPrevRule()"
      ></i>
    </div>
    <div class="col-auto px-0">
      {{ this.stageAdmin.stages.indexOf(this.selectedStage) + 1 }} /
      {{ this.stageAdmin.stages.length }}
    </div>
    <div class="col-auto px-1">
      <i
        class="ri-arrow-right-circle-fill text-primary ri-2x cursor-pointer"
        (click)="selectNextRule()"
      ></i>
    </div>
  </div>
  <div class="row align-items-center mb-2">
    <div class="col-3">
      <span i18n="@@stage-name-indent">Identifikator</span>
    </div>
    <div class="col-3">
      <input
        pInputText
        type="text"
        class="w-100"
        [(ngModel)]="this.selectedStage.name"
        [ngModelOptions]="{ updateOn: 'blur' }"
        (ngModelChange)="
            this.stageAdmin.updateStagesField(
              this.selectedStage._id,
              'name',
              this.selectedStage.name.replaceAll(' ', '')
            )
          "
      />
    </div>
  </div>
  <app-form-for-boolean
    [label]="this.stageHidden"
    [(value)]="this.selectedStage.hidden"
    [colClass]="'col-3'"
    (valueChange)="
        this.stageAdmin.updateStagesField(
          this.selectedStage._id,
          'hidden',
          this.selectedStage.hidden
        )
      "
  >
  </app-form-for-boolean>
  <app-form-for-boolean
    [label]="this.stageFooter"
    [(value)]="this.selectedStage.footer"
    [colClass]="'col-3'"
    (valueChange)="
        this.stageAdmin.updateStagesField(
          this.selectedStage._id,
          'footer',
          this.selectedStage.footer
        )
      "
  >
  </app-form-for-boolean>
  <div class="row mb-2">
    <div class="col-3">
      <span i18n="@@select-skills-in-stage">Verfügbare Skills in Stage</span>
    </div>
    <div class="col-9">
      <p-picklist
        [source]="this.separatedSkillList()"
        [target]="this.targetSkillList()"
        [showSourceControls]="false"
        [showTargetControls]="false"
        (onMoveToSource)="this.saveSkillSelection()"
        (onMoveToTarget)="this.saveSkillSelection()"
        (onMoveAllToSource)="this.saveSkillSelection()"
        (onMoveAllToTarget)="this.saveSkillSelection()"
      >
        <ng-template #sourceHeader>
          <b>Nicht verfügbare Skills</b>
        </ng-template>
        <ng-template #targetHeader>
          <b>Verfügbare Skills</b>
        </ng-template>
        <ng-template
          let-item
          #item
        >
          <div class="d-flex flex-row justify-content-between w-100">
            <div class="d-flex align-items-center gap-2">
              <i [class]="getIconForSkill(item)"></i>
              <span class="font-medium text-sm">
                {{ item }}
              </span>
            </div>
            <a
              [routerLink]="getLinkForSkill(item)"
              [queryParams]="getQueryParamsForSkill(item)"
              class="text-decoration-none"
              style="color: var(--p-primary-500)"
            ><i class="ri-pencil-fill"></i></a>
          </div>
        </ng-template>
      </p-picklist>
    </div>
  </div>
  <app-form-for-boolean
    [label]="this.stageForce"
    [(value)]="this.selectedStage.forceSkills"
    [colClass]="'col-3'"
    (valueChange)="
        this.stageAdmin.updateStagesField(
          this.selectedStage._id,
          'forceSkills',
          this.selectedStage.forceSkills
        )
      "
  >
  </app-form-for-boolean>
  <div class="row align-items-center mb-2">
    <div class="col-3">
      <span i18n="@@pre-js">Vorbedingung für Stage</span>
      <app-hint i18n="@@pre-js-hint">
        Die Vorbedingung stellt den Inhalt eines If-Statements dar und muss
        als Bedingung einen true/false-Wert zurückliefern
      </app-hint>
    </div>
    <div class="col-3">
      <input
        pInputText
        type="text"
        class="w-100"
        [(ngModel)]="this.selectedStage.preConditionJS"
        [ngModelOptions]="{ updateOn: 'blur' }"
        (ngModelChange)="
            this.stageAdmin.updateStagesField(
              this.selectedStage._id,
              'preConditionJS',
              this.selectedStage.preConditionJS
            )
          "
      />
    </div>
  </div>
  <div class="row align-items-center mb-2">
    <div class="col-3">
      <span i18n="@@enter-js">JS-Code für Stage-Einstieg</span>
    </div>
    <div class="col-3">
      <p-button
        severity="primary"
        [outlined]="true"
        [gotoBlockly]="
            this.editorItemService.getEditorItemByUniqueId(
              'stage_enter_' + this.selectedStage._id
            )
          "
        i18n-label="@@to-scripting"
        label="Zum Scripting"
      ></p-button>
    </div>
  </div>
  <div class="row align-items-center mb-2">
    <div class="col-3">
      <span i18n="@@exit-js">JS-Code für Stage-Ausstieg</span>
    </div>
    <div class="col-3">
      <p-button
        severity="primary"
        [outlined]="true"
        [gotoBlockly]="
            this.editorItemService.getEditorItemByUniqueId(
              'stage_exit_' + this.selectedStage._id
            )
          "
        i18n-label="@@to-scripting"
        label="Zum Scripting"
      ></p-button>
    </div>
  </div>
</div>
}